import DatabaseModel from './DatabaseModel.js';

var ViaPago = Object.create(DatabaseModel);

ViaPago.model = 'viapago';
ViaPago.modelFront = 'viaspago';

export default ViaPago;